import { Box, VStack, Text, Button, Heading, Icon, HStack, chakra, Image, Skeleton } from '@chakra-ui/react';
import { FaArrowRight } from 'react-icons/fa';
import Clube from '../../../../../../images/dashboard/clubeDeVantagens.png';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { loadPlans } from 'api/plans';
import { AccountContext } from 'components/AccountContext';
const primaryBgColor = '#5AB2AE';
const priceBgColor = 'rgba(255, 255, 255, 0.2)';

const ClubeVantagens = ({ assinante, clientePendente }) => {
  const [imgLoaded, setImgLoaded] = useState(false);
  const navigate = useNavigate();
  const [menorValor, setMenorValor] = useState(null);
  const { user, toastInadimplente } = useContext(AccountContext);

  useEffect(() => {
    async function fetchMenorValor() {
      try {
        const plans = await loadPlans(user?.code_ibge);

        const menor = plans
          .flatMap((plano) => plano.parcelas || [])
          .map((parcela) => Number(parcela.min_valor))
          .filter((valor) => !isNaN(valor))
          .reduce((acc, curr) => Math.min(acc, curr), Infinity);

        setMenorValor(menor === Infinity ? null : menor);
      } catch (e) {
        setMenorValor(null);
      }
    }

    fetchMenorValor();
  }, []);

  return (
    <Box display="flex" justifyContent="center" alignItems="center" w="100%">
      <Box w="94%" maxW="480px" borderRadius="20px" bg={primaryBgColor} boxShadow="xl" p={{ base: 6, md: 8 }} textAlign="center" color="white">
        <VStack>
          <HStack spacing={2} align="center" justify="center">
            <Skeleton isLoaded={imgLoaded} borderRadius="lg">
              <Image src={Clube} alt="Clube de Vantagens" onLoad={() => setImgLoaded(true)} />
            </Skeleton>
            <Text fontSize="lg">Clube de Vantagens incluso</Text>
          </HStack>

          <Heading as="h2" size="md" fontWeight="extrabold" textAlign="center">
            Centenas de Empresas Parceiras para você economizar ainda mais!
          </Heading>

          <Text fontSize="1em" pb={4} textAlign="center">
            Cinema, compras, farmácias, <br /> educação e muito mais.
          </Text>

          {!assinante && !user?.id_plano && (
            <>
              <Box bg={priceBgColor} borderRadius="lg" p={2} width="fit-content" mt={-5}>
                <VStack spacing={0} align="flex-start">
                  <Text fontSize="sm" textAlign="left">
                    A partir de
                  </Text>

                  <Text fontSize="4xl" fontWeight="bold" textAlign="left">
                    {menorValor ? `R$ ${Number(menorValor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '...'}
                    <chakra.span fontSize="lg" fontWeight="normal">
                      /mês
                    </chakra.span>
                  </Text>
                </VStack>
              </Box>
            </>
          )}

          <Button
            mt={6}
            width="100%"
            color="#424242"
            bg="white"
            minH={'49px'}
            fontSize="1em"
            borderRadius="full"
            rightIcon={<Icon as={FaArrowRight} />}
            onClick={() => {
              if (clientePendente) {
                console.log('Cliente pendente, mostrando toast inadimplente');
                toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
                return;
              }
              if (!assinante) {
                navigate('/cadastro/plano');
                return;
              }
              navigate('/clubeDeVantagens');
            }}
            _focus={{ bg: 'white', color: '#424242', border: 'none' }}
          >
            {!assinante && !clientePendente ? 'Conhecer Planos ' : 'Acessar Benefícios '}
            <chakra.span ml={2} role="img" aria-label="Dinheiro">
              💰
            </chakra.span>
          </Button>
        </VStack>
      </Box>
    </Box>
  );
};

export default ClubeVantagens;
